
<div class="w-100 lm-border pa-3" style="height: 200px">
    <v-row class="no-frame">
        <c-site-tzb-title
            :title         = "$t('unit.tzb.title')"
            :rating        = "data.rating"
            :padding-right = "0"
        />
        <v-row class="no-frame">
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    :value = "data.assessor"
                    :label = "$t('unit.tzb.assessor')"
                    class  = "w-100"
                    :line  = "false"
                    dense
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-read-only-field
                    :value = "date"
                    :label = "$t('unit.tzb.inspection')"
                    class  = "w-100"
                    :line  = "false"
                    dense
                />
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <c-site-tzb-escalator-note
                :data     = "data"
                :editable = "editable"
                :rows     = "3"
            />
        </v-row>
    </v-row>
</div>
